import React, { FC } from 'react';

import { Tag } from '@blueprintjs/core';
import { View } from '@carbon/icons-react';

// eslint-disable-next-line no-restricted-imports
import MessageTooltip from 'components/MessageTooltip/MessageTooltip';

import block from 'utils/bem-css-modules';
import { formatMessage } from 'utils/messages/utils';

import style from './ViewTag.module.pcss';

const b = block(style);

export interface ViewTagProps {
  variant: 'view-only' | 'view-select-hierarchy';
}

export const ViewTag: FC<ViewTagProps> = ({ variant }) => {
  const getConfig = () => {
    switch (variant) {
      case 'view-select-hierarchy':
        return {
          tagContent: 'VIEW_SELECT_HIERARCHY_SEGMENT' as const,
          intent: 'none' as const,
          icon: undefined,
          testId: 'view-select-hierarchy-tag',
          containerTestId: 'view-select-hierarchy-container',
          containerClass: b(),
          tagClass: b('selectHierarchyTag'),
          messageKey: 'VIEW_SELECT_HIERARCHY_SEGMENT' as const
        };

      case 'view-only':
      default:
        return {
          tagContent: 'VIEW_ONLY' as const,
          intent: 'primary' as const,
          icon: <View />,
          testId: 'view-only-tag',
          containerTestId: 'view-only-container',
          containerClass: b(),
          tagClass: b('tag'),
          messageKey: 'VIEW_ONLY_TOOLTIP' as const
        };
    }
  };

  const config = getConfig();

  return (
    <MessageTooltip
      content={formatMessage(config.messageKey)}
      placement="bottom"
      target={
        <div data-testid={config.containerTestId} className={config.containerClass}>
          <Tag
            intent={config.intent}
            minimal
            icon={config.icon}
            data-testid={config.testId}
            className={config.tagClass}
          >
            {formatMessage(config.tagContent)}
          </Tag>
        </div>
      }
    />
  );
};
